import React, { useContext } from 'react';
import { Typography } from 'fronton-react';
import { TProjectConfigurationParameter } from 'pages/common/types';
import { getRoomTypeTitle } from 'pages/common/helpers/get-room-type-title';
import { getAreaUser } from 'pages/common/helpers/get-area-user.helper';
import { RouteContext } from 'entries/common/widgets/saved-project-configuration/context';
import { TRoomsParams } from 'common/types/floor-params.type';
import { EditParamsButton } from './EditParamsButton';
import { AdditionalInfo } from './AdditionalInfo';
import { routes } from '../../consts/routes';
import {
  RoomParamsContainer,
  ParamsListContainer,
  ParamsListTitle,
  ParamsListRow,
  ParamsListColumnRight,
} from './styles';

type TProps = {
  configurationParameters: Array<TProjectConfigurationParameter>;
};

export const RoomParams: React.FC<TProps> = ({ configurationParameters }: TProps) => {
  const { setRoute } = useContext(RouteContext);
  const area = configurationParameters.find(param => param.key === 'area')?.value;
  const areaUser = area
    ? getAreaUser({
        areaUser: Number(area),
      })
    : 0;
  const roomType = configurationParameters.find(param => param.key === 'roomType')?.value;
  const roomTypeTitle = getRoomTypeTitle({ roomType } as TRoomsParams);
  const typeInstallation = configurationParameters.find(param => param.key === 'layingType')?.value;

  const handleClick = () => {
    setRoute(routes.dimensions);
  };

  return (
    <RoomParamsContainer data-testid="calculation-params-list" onClick={handleClick}>
      <ParamsListContainer>
        <ParamsListRow>
          <ParamsListTitle>
            <Typography color="text-primary" size="subtitle" variant="m" data-testid="configuration-title">
              {roomTypeTitle}&nbsp;
            </Typography>
            <Typography color="text-primary" size="subtitle" variant="m" data-testid="configuration-value">
              {`${areaUser} м²`}
            </Typography>
          </ParamsListTitle>
          <ParamsListColumnRight>
            <EditParamsButton />
          </ParamsListColumnRight>
        </ParamsListRow>
        <AdditionalInfo typeInstallation={typeInstallation} />
      </ParamsListContainer>
    </RoomParamsContainer>
  );
};
